import Ajax from 'global/od/Ajax';
import ModalManager from 'global/modal/ModalManager';
import { getNodeFromString } from 'global/common/globalUtils';

const UPDATE_URL = '/ajax/premiumshop/gift/update';
const BACK_ORDER_MODAL_ID = 'addToCartBackOrder';

const getQtyInput = form => form.querySelector('[data-article-number]');

const getUpdateFormData = form => {
	const qtyInput = getQtyInput(form);
	if (!qtyInput) return null;
	return {
		productCode: qtyInput.dataset.articleNumber,
		qty: parseInt(qtyInput.value, 10),
	};
};

const toggleUpdateButton = input => {
	const wrapper = input
		.closest('form')
		?.querySelector('.product-row-base__update-btn-wrap');
	if (!wrapper) return;

	const hasChanged = input.value !== input.defaultValue;

	wrapper.classList.toggle(
		'product-row-base__update-btn-wrap--visible',
		hasChanged,
	);
};

const restorePreviousQuantity = form => {
	const qtyInput = getQtyInput(form);
	if (!qtyInput) return;

	qtyInput.value = qtyInput.defaultValue;
	toggleUpdateButton(qtyInput);
};

const postUpdate = (productCode, qty) =>
	Ajax({
		url: UPDATE_URL,
		method: 'POST',
		dataType: 'html',
		data: { productCode, qty },
	}).then(() => window.location.reload());

const showBackOrderModal = (data, form) => {
	const modalManager = new ModalManager();
	modalManager.insertResponse(data, BACK_ORDER_MODAL_ID);

	const modalHtml = modalManager.modal.element;
	const continueButton = modalHtml.querySelector('#addToCartBackOrderCheckout');
	if (!continueButton) return;

	continueButton.addEventListener('click', e => {
		e.preventDefault();

		const selectedOption = modalHtml.querySelector(
			'input[name=stock-option]:checked',
		);
		const qty = parseInt(selectedOption?.value, 10);

		if (!qty) {
			restorePreviousQuantity(form);
			modalManager.modal.hide();
			return;
		}

		postUpdate(getQtyInput(form).dataset.articleNumber, qty);
	});
};

const handleUpdateClick = e => {
	e.preventDefault();
	const form = e.currentTarget.closest('form');
	if (!form) return;

	const formData = getUpdateFormData(form);
	if (!formData || !formData.productCode || formData.qty < 0) return;

	Ajax({
		url: UPDATE_URL,
		method: 'POST',
		dataType: 'html',
		data: formData,
	}).then(({ data }) => {
		if (getNodeFromString(data)?.id === BACK_ORDER_MODAL_ID) {
			showBackOrderModal(data, form);
			return;
		}

		window.location.reload();
	});
};

const premiumShopGiftUpdate = wallet => {
	const updateButtons = wallet.querySelectorAll('.product-row-update-button');
	updateButtons.forEach(button =>
		button.addEventListener('click', handleUpdateClick),
	);

	const qtyInputs = wallet.querySelectorAll('input[data-quantity]');

	qtyInputs.forEach(input => {
		input.addEventListener('input', () => toggleUpdateButton(input));
		input.addEventListener('blur', () => toggleUpdateButton(input));
	});
};

export default premiumShopGiftUpdate;
